import { HTMLAttributes } from 'react';
import { StatusIconStylesVariants, statusIconStyles } from './variants';
import { twMerge } from 'tailwind-merge';

type Props = StatusIconStylesVariants &
  Omit<HTMLAttributes<HTMLDivElement>, 'color'>;

export function StatusIcon(props: Props) {
  const {
    className,
    variant = 'circular',
    color = 'default',
    children,
    ...rest
  } = props;

  return (
    <div
      className={twMerge(statusIconStyles({ color, variant }), className)}
      role="status"
      {...rest}
    />
  );
}
